import { formatCurrency } from '../../../../utils/currency';
export function getStripePublicKey() {
  return process.env.STRIPE_API_KEY || process.env.STORYBOOK_STRIPE_API_KEY;
}
export function getPlaceOrderButtonText() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isSmallScreen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (isSmallScreen) {
    var _order$total = order.total,
      total = _order$total === void 0 ? 0.0 : _order$total;
    return "Place Order \xB7 ".concat(formatCurrency(total));
  }
  return 'Place Order';
}